module.exports = __webpack_public_path__ + "static/tree2@2x-d8041fa10fd264537209d465dbc13fa9.png";